<template>
  <div class="home">
      <!-- 头部 -->
      <el-header>
        <div class="head">
          <img @click="drawer=!drawer" class="img1" src="@/assets/img/menu.png" alt="">
          <img @click="$router.go(0)" src="@/assets/img/logo.png" alt="" />
          <span @click="$router.go(0)"> F A X C H A I N</span>
        </div>
        <div class="langs">
          <select :value="lang" @change="switchLang" class="slt">
            <option value="en">English</option>
            <option value="cn">简体中文</option>
          </select>
        </div>
      </el-header>
      <el-drawer title="F A X C H A I N" :visible.sync="drawer" direction="ltr" size="80%">
        <div>
          <Side-Bar @selectedIndex="selectedIndex"></Side-Bar>
        </div>
      </el-drawer>
      <el-container class="mains">
        <!-- 侧边栏 -->
        <el-aside width="20%">
          <Side-Bar @selectedIndex="selectedIndex"></Side-Bar>
        </el-aside>
        <!-- main -->
        <el-main>
          <!-- <div style="padding:15px 0">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>活动管理</el-breadcrumb-item>
            </el-breadcrumb>
          </div> -->
          <Main :index="index"></Main>
        </el-main>
        
      </el-container>
      <el-footer>
        <div class="foot">
          <div class="left">
            <div style="font-size:18px;font-weight:700">Community</div>
            <div>Discord</div>
            <div>Twitter</div>
            <div>Telegram</div>
            <div>Medium</div>
          </div>
          <div class="right">
            <div style="font-size:18px;font-weight:700">More</div>
            <div>YouTube</div>
            <div>Ecosystem</div>
            <div>GitHub</div>
          </div>
        </div>
        <p class="copyRight">Copyright © 2022 Fax Labs, Inc.</p>
      </el-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import SideBar from '@/components/sideBar.vue'
import Main from '@/views/main.vue'

export default {
  name: "Home",
  components: {
    Main,
    SideBar
  },
  data() {
    return {
      lang: window.sessionStorage.getItem('lang') || 'cn',
      index: '0',
      drawer:false
    }
  },
  created() {
    window.sessionStorage.setItem('lang',this.$i18n.locale)
  },
  methods: {
    switchLang() {
      return
      if(window.sessionStorage.getItem('lang') == 'cn') {
        this.$i18n.locale = 'en'
        window.sessionStorage.setItem('lang','en')
        // this.$router.go(0)
      }
      else {
        this.$i18n.locale = 'cn'
        window.sessionStorage.setItem('lang','cn')
        // this.$router.go(0)
      }
    },
    selectedIndex(i) {
      this.index = i
      this.drawer = false
    }
  }
};
</script>
<style lang="sass" scoped>
@media screen and (min-width:980px)
  .home
    .el-header
      display: flex
      align-items: center
      justify-content: space-between
      position: fixed
      top: 0
      left: 0
      right: 0
      z-index: 999
      width: 100%
      border-bottom: 1px solid #DADDE1
      padding: 0 15px
      background: #fff
      line-height: 60px
      .langs
        .slt
          width: 80px
          height: 25px
          border-radius: 5px
      .head
        display: flex
        align-items: center
        color: #7549A9
        font-weight: 700
        .img1
          display: none
        img
          margin-right: 5px
          width: 37px
          height: 32px
    .el-aside
      padding-bottom: 50px
      position: sticky
      top: 60px
      overflow: auto
      margin-top: 60px
      height: 800px
  
    .el-main
      margin-top: 50px
      height: 100%
      .scrolls
        width: 200px
    .el-footer
      padding: 0
      color: #fff
      .foot
        width: 100%
        // padding: 10px 20px
        display: flex
        background: #7549A9
        height: 180px
        .left
          padding: 20px 80px
          width: 200px
          line-height: 35px
        .right
          padding: 20px 80px
          width: 200px
          line-height: 35px
      .copyRight
        text-align: center
        background: #7549A9
        line-height: 80px
        
@media screen and (max-width:980px)
  .home
    .mains
      margin-top: 60px
    .el-header
      display: flex
      align-items: center
      justify-content: space-between
      position: fixed
      top: 0
      left: 0
      // z-index: 3
      width: 100%
      border-bottom: 1px solid #DADDE1
      padding: 0 15px
      color: #333
      line-height: 60px
      background: #fff
      .langs
        .slt
          width: 80px
          height: 25px
          border-radius: 5px
          background: #fff
      .head
        display: flex
        align-items: center
        color: #7549A9
        font-weight: 700
        .img1
          width: 28px
        img
          margin-right: 5px
          width: 37px
          height: 32px
    .el-aside
      display: none
      // background-color: #D3DCE6
      // color: #333
      line-height: 200px
  
    .el-main
      padding: 10px
      // background-color: #E9EEF3
      // color: #333
    .el-footer
      padding: 0
      color: #fff
      .foot
        width: 100%
        // padding: 10px
        // display: flex
        background: #7549A9
        // height: 150px
        .left
          padding: 20px
          width: 200px
          line-height: 35px
        .right
          padding: 20px
          width: 200px
          line-height: 35px
      .copyRight
        text-align: center
        background: #7549A9
        line-height: 60px
</style>
